import { createActions, createReducer } from 'reduxsauce'

import ArquivosAnexosService from '../../servicos/ArquivosAnexosService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaArquivosDespesasCartaoCorporativoInicio: [],
    buscaArquivosDespesasCartaoCorporativoSucesso: ['arquivosDespesasCartaoCorporativo'],
    buscaArquivosDespesasCartaoCorporativoErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
}

// Ação para busca completa
Creators.buscaArquivosDespesasCartaoCorporativo = filtro => {
    return dispatch => {
        dispatch(Creators.buscaArquivosDespesasCartaoCorporativoInicio())
        let serv = new ArquivosAnexosService()
        return serv
            .consultarAnexosDespesasCartaoCorporativo(filtro)
            .then(response => dispatch(Creators.buscaArquivosDespesasCartaoCorporativoSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaArquivosDespesasCartaoCorporativoErro(error)))
    }
}

const buscaArquivosDespesasCartaoCorporativoInicio = (state = INITIAL_STATE, action) => {
    return { ...state, carregando: true, erro: null }
}

const buscaArquivosDespesasCartaoCorporativoErro = (state = INITIAL_STATE, action) => {
    return { ...state, erro: action.erro, carregando: false }
}

const buscaArquivosDespesasCartaoCorporativoSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.arquivosDespesasCartaoCorporativo, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_ARQUIVOS_DESPESAS_CARTAO_CORPORATIVO_INICIO]: buscaArquivosDespesasCartaoCorporativoInicio,
    [Types.BUSCA_ARQUIVOS_DESPESAS_CARTAO_CORPORATIVO_ERRO]: buscaArquivosDespesasCartaoCorporativoErro,
    [Types.BUSCA_ARQUIVOS_DESPESAS_CARTAO_CORPORATIVO_SUCESSO]: buscaArquivosDespesasCartaoCorporativoSucesso,
})
